<med-toolbar color="primary">
  <med-logo slot="logo"></med-logo>
  <med-spacer></med-spacer>
  <div>
    <div fxLayout="row" class="mt-5">
      <mcp-study-select></mcp-study-select>
      <mcp-user-menu></mcp-user-menu>
      <mcp-help-menu></mcp-help-menu>
      <mcp-logout></mcp-logout>
    </div>
    <div id="app-row" class="mb-3 mr-10" fxLayout="row" fxLayoutAlign="end center">
      <mcp-apps-menu></mcp-apps-menu>
      <span id="customer-name" class="fs-14 ml-10">{{customerName}}</span>
    </div>
  </div>
</med-toolbar>
